import * as React from 'react';

import PropTypes from 'prop-types';

import styles from './action-option.module.css';

export class ActionOption extends React.Component {
    static propTypes = {
        entity: PropTypes.shape({
            name: PropTypes.string.isRequired,
            type: PropTypes.string,
        }),
        value: PropTypes.string.isRequired,
    };

    render() {
        const {entity, value} = this.props;
        const containerType = this.getContainerType();

        return (
            <div>
                <div className={styles[`action-title-${containerType}`]}>{entity.name}</div>
                <div>{value}</div>
            </div>
        );
    }

    getContainerType = () => {
        switch (this.props.entity.type) {
            case 'accounts':
            case 'contacts':
                return this.props.entity.type;
            default:
                return 'default';
        }
    };
}
